module.exports = __webpack_public_path__ + "img/cp_gc.eb3ee62c.png";